import angular from 'angular';
import springDataTableComponent from './springDataTable.component';


let springDataTableModule = angular.module('springDataTable', [
])

.component('springDataTable', springDataTableComponent);

export default springDataTableModule;



// WEBPACK FOOTER //
// ./client/common/springDataTable/springDataTable.js